import { normalizePositions, toEpochMs, bundleTimeRange } from '../core/track.js';

const EVENT_LABELS = {
    CONVERTSESSION: 'Changement de mode',
    STATECHANGE: 'Changement d’état',
    RESPONDER_UPDATE: 'Intervenant',
    SESSION_STARTED: 'Début de session',
};

/**
 * Session d'alerte ou de partage → ActivityBundle (une piste : la personne
 * suivie). Les positions viennent du cache de timeline du lecteur web, déjà
 * déchiffrées ; la vidéo est le flux HLS de la session.
 */
export function alertSessionToBundle({ sessionId, details, positions, events = [], playlistUrl = null, title = null, journal = null }) {
    const session = details || {};
    const track = {
        id: 'owner',
        userId: session.userId ?? null,
        label: 'Personne suivie',
        role: session.sessionType || 'Session',
        color: '#ef4444',
        positions: normalizePositions((positions || []).map(point => ({
            t: point.timestamp ?? point.t,
            lat: point.lat ?? point.latitude,
            lng: point.lng ?? point.longitude,
            accuracy: point.accuracy ?? null,
            inZone: null,
        }))),
        media: [],
        photos: [],
    };
    if (playlistUrl && ['audio', 'video'].includes(session.mediaType)) {
        const start = toEpochMs(session.createdAt) ?? track.positions[0]?.t ?? null;
        track.media.push({
            id: `${sessionId}-${session.mediaType}`,
            type: session.mediaType,
            label: session.mediaType === 'video' ? 'Vidéo' : 'Audio',
            playlistUrl,
            startMs: start,
            endMs: track.positions[track.positions.length - 1]?.t ?? start,
        });
    }
    // Avec le journal de la session : une ligne par événement, même texte qu'à l'écran.
    const bundleEvents = journal ? journal.map(entry => ({
        t: entry.t, kind: entry.kind || 'event', label: entry.label, trackId: 'owner', responder: entry.responder || null,
    })) : events
        .map(event => ({
            t: toEpochMs(event.timestamp),
            kind: event.eventType === 'CONVERTSESSION' ? 'alert' : 'state',
            label: EVENT_LABELS[event.eventType] || event.eventType || 'Événement',
            trackId: 'owner',
        }))
        .filter(event => event.t !== null && event.label !== 'NEWPOSITION');
    const bundle = {
        id: sessionId,
        kind: 'SESSION',
        title: title || (session.sessionType ? `Session ${session.sessionType}` : 'Session MonAlerte'),
        status: session.status,
        address: null,
        zone: { polygon: null, center: null, radiusMeters: null },
        tracks: [track],
        messages: [],
        events: bundleEvents,
    };
    const range = bundleTimeRange(bundle);
    bundle.startMs = range.startMs;
    bundle.endMs = range.endMs;
    return bundle;
}
